import {Component, Input, OnInit} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';
import {RiskLocationService} from '../../../services/proposal-service/risk-location.service';
import {Risks} from '../../../model/risks';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../../store/user/reducers/user.reducer';
import {selectUserPermissions} from '../../../store/auth/selectors/auth.selectors';
import {Permissions} from '../../../enum/permissions';
import {environment} from '../../../../environments/environment';
import {Route} from '../../../enum/route';
import {selectUserId} from '../../../store/user/selectors/user.selectors';
import {getCurrencySymbol} from '@angular/common';

@Component({
    selector: 'app-insurance-contract-detail-risk-locations',
    templateUrl: './insurance-contract-detail-risk-locations.component.html',
    styleUrls: ['./insurance-contract-detail-risk-locations.component.scss'],
    standalone: false
})
export class InsuranceContractDetailRiskLocationsComponent implements OnInit{

  @Input() proposal: Proposal;

  geoLocations: Map<string, string> = new Map();
  risks: Map<string, Risks> = new Map();
  permissions = this.userStore.select(selectUserPermissions);
  userId$ = this.userStore.select(selectUserId);

  constructor(private readonly riskLocationService: RiskLocationService,
              private readonly userStore: Store<UserAppState>) {
  }

  ngOnInit() {
    this.proposal.riskLocations.forEach(rl => {
      this.riskLocationService.getGeoLocationByAddress(rl.houseNumber + ' ' + rl.street + ', ' + rl.location + ', ' + rl.countryCode)
        .subscribe(gl => {
          this.geoLocations.set(rl.street, gl.lat + ', ' + gl.lng);
          this.userStore.select(selectUserPermissions).subscribe(permissions => {
            if (permissions.includes(Permissions.read_kis_api)) {
              this.riskLocationService.submitGeoLocationToKIS(gl).subscribe(risk => this.risks.set(rl.street, risk));
            }
          })
        });
    });
  }

  checkNullRisk(risk: Risks): boolean {
    if (!risk) return true;
    return risk.flood === '0' && risk.cyclones == '0' && risk.earthquake == '0' && risk.seaWater == '0' && risk.hail == '0' && risk.localPoliticsDanger == '0'
           && risk.nationalPoliticsDanger == '0' && risk.tsunamis == '0' && risk.winterStorm == '0';
  }

  currencySymbol() {
    return getCurrencySymbol(this.proposal.proposalInformation.currency, 'narrow');
  }
  protected readonly Permissions = Permissions;
  protected readonly environment = environment;
  protected readonly Route = Route;
}
